import { FormattedMessage } from 'react-intl';

export function PasswordHints() {
  return (
    <ul>
      <li>
        <FormattedMessage
          id="create-password-page.password-hint-min-size"
          defaultMessage="At least eight characters"
        />
      </li>
      <li>
        <FormattedMessage
          id="create-password-page.password-hint-letter"
          defaultMessage="At least one capital letter"
        />
      </li>
      <li>
        <FormattedMessage
          id="create-password-page.password-hint-number"
          defaultMessage="At least one number"
        />
      </li>
      <li>
        <FormattedMessage
          id="create-password-page.password-hint-special-chars"
          defaultMessage="At least one special character: {specialChars}"
          values={{
            specialChars: '!@#$%^&*()_+:',
          }}
        />
      </li>
    </ul>
  );
}
